import { render, staticRenderFns } from "./b25.vue?vue&type=template&id=16e3dde2&scoped=true"
import script from "./b25.vue?vue&type=script&lang=js"
export * from "./b25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3dde2",
  null
  
)

export default component.exports